<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-book">
<h1>About the Book</h1>
<p>Magellan Point is a novel about the lives of people living in the Western Pacific and their efforts to create political institutions that encompass many islands—efforts that resulted in states in Micronesia and the territory of the Northern Marianas Islands.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?1ca06142